import { Component, EventEmitter, Inject, Input, Output } from '@angular/core'
import { APP_CONFIG } from 'src/app/app.config'
import { AppConfigModel } from 'src/app/core/models'

@Component({
  selector: 'app-simulation-editor-intro-dialog',
  templateUrl: './simulation-editor-intro-dialog.component.html',
  styleUrls: ['./simulation-editor-intro-dialog.component.scss'],
  standalone: false,
})
export class SimulationEditorIntroDialogComponent {
  @Input() public dontShowAgain = false
  @Input() public showDontShowAgain = true

  @Output() public dontShowAgainChange = new EventEmitter<boolean>()

  public howToVideoUrl = ''
  public legacyVideoUrl = ''
  public corruptedVideoUrl = ''

  constructor(@Inject(APP_CONFIG) private readonly config: AppConfigModel) {
    this.howToVideoUrl = this.buildVideoUrl('HowTo.mp4')
    this.legacyVideoUrl = this.buildVideoUrl('Legacy_Import.mp4')
    this.corruptedVideoUrl = this.buildVideoUrl('Corrupted_Simulations.mp4')
  }

  private buildVideoUrl(fileName: string): string {
    if (!fileName) {
      return ''
    }

    if (/^https?:\/\//i.test(fileName)) {
      return fileName
    }

    const baseUrl = this.config?.rcs_frontend_assets_base_url?.replace(/\/$/, '')
    const sasToken = this.config?.rcs_frontend_assets_sas_token ?? ''

    if (!baseUrl) {
      return ''
    }

    return `${baseUrl}/${fileName}${sasToken}`
  }
}
